// Add your JS customizations here
jQuery(document).ready(function($) {
	new WOW().init();

	function setEqualHeight(group) {
		var maxHeight = 0;

		// reset heights first
		$(group).css('height', 'auto');

		// find tallest
		$(group).each(function() {
			var thisHeight = $(this).outerHeight();
			if (thisHeight > maxHeight) {
				maxHeight = thisHeight;
			}
		});

		// apply tallest
		if (maxHeight > 0) {
			$(group).css('height', maxHeight);
		}
	}

	function applyEqualHeights() {
		var processed = [];
		$('[class*="equal-height-"]').each(function() {
			var classes = $(this).attr('class').split(/\s+/);
			$.each(classes, function(i, c) {
				if (c.indexOf('equal-height-') === 0 && processed.indexOf(c) === -1) {
					setEqualHeight('.' + c);
					processed.push(c);
				}
			});
		});
	}

	// Run once page is fully loaded (images included)
	$(window).on('load', function() {
		applyEqualHeights();
	});

	// Re-run on resize
	$(window).on('resize', function() {
		applyEqualHeights();
	});



	$('a[href^="#"]').on('click', function(e) {
		var target = $(this.getAttribute('href'));

		if (target.length) {
			e.preventDefault();

			$('html, body').animate({
				scrollTop: target.offset().top - 100
			}, 800);
		}
	});

	$('.af-features-slider').slick({
		slidesToShow: 2.15,
		slidesToScroll: 1,
		infinite: false,
		arrows: false,
		dots: false,
		autoplay: true,
		autoplaySpeed: 4000,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1.15
				}
			}
		]
	});

	$('.whats-included-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		autoplay: true,
		autoplaySpeed: 4000,
		adaptiveHeight: true,
		prevArrow: $('.whats-included-slick-prev'),
		nextArrow: $('.whats-included-slick-next'),
		fade: true,
		cssEase: 'linear'
	});

	$('.testimonial-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		autoplay: true,
		autoplaySpeed: 4000,
		adaptiveHeight: true,
		prevArrow: $('.testimonial-slick-prev'),
		nextArrow: $('.testimonial-slick-next'),
		fade: true,
		cssEase: 'linear',
	});

	$('.footer-accreditations-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2500,
		arrows: false,
		dots: false,
		centerMode: false,
		infinite: true,
		variableWidth: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	$('.floor-plans-slider').slick({
		slidesToShow: 2.1,
		slidesToScroll: 1,
		infinite: false,
		arrows: false,
		dots: false,
		draggable: true,
		swipeToSlide: true,
		touchThreshold: 20,
		autoplay: false, // start off
		autoplaySpeed: 4000,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1.1
				}
			}
		]
	});

	const slider = document.querySelector('.floor-plans-slider');

	if (slider && 'IntersectionObserver' in window) {
		let observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					$('.floor-plans-slider').slick('slickPlay');
				} else {
					$('.floor-plans-slider').slick('slickPause');
				}
			});
		}, { threshold: 0.3 });

		observer.observe(slider);
	}



	function equalizeHeights(containerSelector, blockSelector) {
		$(containerSelector).each(function() {
			var maxHeight = 0;
			var $blocks = $(this).find(blockSelector);

			// Reset heights first
			$blocks.css('height', 'auto');

			// Find max height
			$blocks.each(function() {
				var blockHeight = $(this).outerHeight();
				if (blockHeight > maxHeight) {
					maxHeight = blockHeight;
				}
			});

			// Apply max height
			$blocks.css('height', maxHeight + 'px');
		});
	}

	// Example usage for your "whats-included" rows
	equalizeHeights('.included-blocks-row', '.included-block .position-relative', 'register-interest-wrapper');

	// Run on window resize
	$(window).on('resize', function() {
		equalizeHeights('.included-blocks-row', '.included-block .position-relative','register-interest-wrapper');
	});



	function applyNavHeight() {
		var nav = $(".nav-wrapper");
		if (!nav.length) return;

		var navHeight = nav.outerHeight();

		$(".add-nav-height").css("height", navHeight + "px");
		$(".mt-nav-height").css("margin-top", navHeight + "px");
		$(".pt-nav-height").css("padding-top", navHeight + "px");
	}

	// Run on load + resize
	applyNavHeight();
	$(window).on("resize", applyNavHeight);



	const allMenus = $('.inner-wrapper');
	const mainMenu = $('.main-menu');
	const mobileMenuExpand = $('.mobile-menu-expand');
	const menuTriggerIcon = $('.mobile-menu-trigger'); // target the <i> inside the trigger

	// handle main mobile menu trigger
	$('.mobile-menu-trigger').on('click', function(e) {
		e.preventDefault();

		const $icon = $(this); // the clicked <i>

		if (mobileMenuExpand.hasClass('active')) {
			// close menu
			mobileMenuExpand.removeClass('active');
			allMenus.removeClass('active');
			mainMenu.addClass('active');
			$('body').removeClass('no-scroll');

			// change icon back to bars
			$icon.removeClass('fa-xmark').addClass('fa-bars');
		} else {
			// open menu
			mobileMenuExpand.addClass('active');
			allMenus.removeClass('active');
			mainMenu.addClass('active');
			$('body').addClass('no-scroll');

			// change icon to xmark
			$icon.removeClass('fa-bars').addClass('fa-xmark');
		}
	});

	// handle inner menu triggers (e.g., accommodation)
	$('.menu-trigger').on('click', function(e) {
		e.preventDefault();
		allMenus.removeClass('active');

		if ($(this).hasClass('accommodation-menu-trigger')) {
			$('.accommodation-menu').addClass('active');
		} else {
			mainMenu.addClass('active');
		}
	});

	// return to main menu buttons inside menus
	$('.inner-wrapper .return-main-menu').on('click', function() {
		allMenus.removeClass('active');
		mainMenu.addClass('active');
	});

	// optional: close menu by clicking outside or a close button
	$('.mobile-menu-expand-close').on('click', function() {
		mobileMenuExpand.removeClass('active');
		allMenus.removeClass('active');
		mainMenu.addClass('active');
		$('body').removeClass('no-scroll'); // enable body scroll
	});



	var popupWrapper = $('.register-interest-popup-wrapper');
	var popupClosed = sessionStorage.getItem('registerInterestClosed');

	// Hide popup initially
	popupWrapper.hide();

	// Only show if user hasn't closed it during this session
	if (!popupClosed) {
		setTimeout(function() {
			popupWrapper.fadeIn(400);
		}, 6000); // 6000ms = 6 seconds
	}

	// Close button click
	$('.register-interest-close').on('click', function(e) {
		e.preventDefault();

		popupWrapper.fadeOut(300);

		// Remember the user closed it (only until tab/browser is closed)
		sessionStorage.setItem('registerInterestClosed', 'true');
	});



	/*
		Profile Page JS Functionality
	*/

	// On Click Display Functionality
	$(".section-selector .select-section").on("click", function() {
		var section = $(this).data("section");

		// Toggle headings
		$(".section-heading h2").addClass("d-none");
		$('.section-heading h2[data-section="' + section + '"]').removeClass("d-none");

		// Update active class for selector
		$(".section-selector .select-section").removeClass("active");
		$(this).addClass("active");

		// Toggle template sections ONLY
		$(".template-section").each(function() {
			if ($(this).data("section") === section) {
				$(this).removeClass("d-none");
			} else {
				$(this).addClass("d-none");
			}
		});

		// On mobile: close the dropdown after selecting
		if (window.innerWidth < 992) {
			$(".tenant-selector.mobile-control").removeClass("active");
		}
	});

	// On click visibility for Password Reset
	$('.reset-pw-trigger').on('click', function() {
		// Hide the trigger wrapper
		$('.reset-pw-trigger-wrapper').hide();

		// Show the reset form
		$('.reset-wrapper').removeClass('d-none');
	});

	$('#mobile-section-btn').click(function() {
		$('.tenant-selector.mobile-control').toggleClass('active');
	});


	jQuery('select.gfield_select').select2({ width: '100%' });



});



document.addEventListener("DOMContentLoaded", function() {
	if (!document.body.classList.contains("page-template-tmpl-tenant-portal-php")) {
		return;
	}

	const saveBtn = document.getElementById("save-profile-btn");
	const saveMessage = document.getElementById("save-message");
	let selectedImageId = null;

	// Toggle profile edit sections
	document.querySelectorAll(".edit-profile-btn").forEach(btn => {
		btn.addEventListener("click", function() {
			const container = btn.closest(".profile-section");
			container.querySelector(".profile-view").style.display = "none";
			container.querySelector(".profile-edit").style.display = "block";
		});
	});

	document.querySelectorAll(".cancel-profile-edit").forEach(btn => {
		btn.addEventListener("click", function() {
			const container = btn.closest(".profile-section");
			container.querySelector(".profile-edit").style.display = "none";
			container.querySelector(".profile-view").style.display = "block";
		});
	});

	// Image upload handling
	document.querySelectorAll(".edit-image-btn").forEach(btn => {
		btn.addEventListener("click", function(e) {
			e.preventDefault();

			let frame = wp.media({
				title: "Upload Profile Image",
				button: { text: "Use this image" },
				library: { type: "image" },
				multiple: false
			});

			frame.on("open", function() {
				frame.content.mode('upload');
				frame.$el.find('.media-menu-item').remove();
			});

			frame.on("select", function() {
				const attachment = frame.state().get("selection").first().toJSON();
				const imgDisplay = btn.closest(".inner-wrapper-styles").querySelector(".profile-image-display");
				if (imgDisplay) imgDisplay.src = attachment.url;
				selectedImageId = attachment.id;
			});

			frame.open();
		});
	});

	// Save profile via AJAX
	saveBtn.addEventListener("click", function() {
		const firstName = document.querySelector(".first-name-input")?.value.trim() || '';
		const surname = document.querySelector(".surname-input")?.value.trim() || '';
		const telNumber = document.querySelector(".tel-number-input")?.value.trim() || '';
		const userEmail = document.querySelector(".user-email-input")?.value.trim() || '';
		const otherContact = document.querySelector(".other-contact-input")?.value.trim() || '';

		const data = new URLSearchParams({
			action: 'save_user_profile',
			user_id: tenantPortalData.userId,
			first_name: firstName,
			surname: surname,
			tel_number: telNumber,
			user_email: userEmail,
			other_contact: otherContact,
			image_id: selectedImageId || '',
			_ajax_nonce: tenantPortalData.nonce
		});

		fetch(tenantPortalData.ajaxUrl, {
			method: "POST",
			headers: { "Content-Type": "application/x-www-form-urlencoded" },
			body: data
		})
		.then(res => res.json())
		.then(res => {
			if (res.success) {
				saveMessage.style.display = "block";
				saveMessage.textContent = "Profile updated successfully!";

				// Reload page after 500ms to show updated data
				setTimeout(() => location.reload(), 500);
			} else {
				saveMessage.style.display = "block";
				saveMessage.textContent = "Error updating profile. Please try again.";
				setTimeout(() => saveMessage.style.display = "none", 3000);
			}
		})
		.catch(() => {
			saveMessage.style.display = "block";
			saveMessage.textContent = "Error updating profile. Please try again.";
			setTimeout(() => saveMessage.style.display = "none", 3000);
		});
	});

});



document.addEventListener('DOMContentLoaded', function() {
	var username = document.getElementById('user_login');
	var password = document.getElementById('user_pass');

	if (username) {
		username.setAttribute('placeholder', 'Username');
	}

	if (password) {
		password.setAttribute('placeholder', 'Password');

		// Wrap password input in a container with custom class
		var wrapper = document.createElement('div');
		wrapper.classList.add('password-wrapper');
		password.parentNode.insertBefore(wrapper, password);
		wrapper.appendChild(password);

		// Add toggle button with custom class
		var toggleBtn = document.createElement('button');
		toggleBtn.type = 'button';
		toggleBtn.classList.add('password-toggle');
		toggleBtn.innerHTML = '<i class="fa-solid fa-eye"></i>';
		toggleBtn.setAttribute('aria-label', 'Show password');

		wrapper.appendChild(toggleBtn);

		toggleBtn.addEventListener('click', function() {
			var isHidden = password.type === 'password';
			password.type = isHidden ? 'text' : 'password';
			toggleBtn.innerHTML = isHidden
				? '<i class="fa-solid fa-eye-slash"></i>'
				: '<i class="fa-solid fa-eye"></i>';
			toggleBtn.setAttribute('aria-label', isHidden ? 'Hide password' : 'Show password');
		});
	}
});

document.addEventListener("DOMContentLoaded", function() {
	gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

	const smoother = ScrollSmoother.create({
		wrapper: "#smooth-wrapper",
		content: "#smooth-content",
		smooth: 2.0,
		effects: true
	});

	// Apply parallax to your images
	gsap.utils.toArray(".image_cont img").forEach(img => {
		smoother.effects(img, { speed: "auto" });
	});
});